import { colors } from '@mui/material';
import Typography from '@mui/material/Typography';

export const TextBody1: React.FC<React.PropsWithChildren<{ disabled?: boolean }>> = ({ children, disabled }) => {
  return (
    <Typography
      variant="body1"
      sx={{
        whiteSpace: 'pre-wrap',
        backgroundColor: colors.grey[50],
        p: 1,
        //borderBottom: `1px dashed ${colors.grey[400]}`,
      }}
      color={disabled ? colors.grey[400] : undefined}
    >
      {children}
    </Typography>
  );
};
